Shopware.Component.extend('sw-cms-el-acris-blog-image', 'sw-cms-el-image', () => import('./component'));
Shopware.Component.extend('sw-cms-el-config-acris-blog-image', 'sw-cms-el-config-image', () => import('./config'));
import './preview';

Shopware.Service('cmsService').registerCmsElement({
    name: 'acris-blog-image',
    label: 'acris-blog.elements.blogImage.label',
    component: 'sw-cms-el-acris-blog-image',
    configComponent: 'sw-cms-el-config-acris-blog-image',
    previewComponent: 'sw-cms-el-preview-acris-blog-image',
    defaultConfig: {
        media: {
            source: 'static',
            value: null,
            required: true,
            entity: {
                name: 'media',
            },
        },
        displayMode: {
            source: 'static',
            value: 'standard',
        },
        url: {
            source: 'static',
            value: null,
        },
        newTab: {
            source: 'static',
            value: false,
        },
        minHeight: {
            source: 'static',
            value: '400px',
        },
        verticalAlign: {
            source: 'static',
            value: 'center',
        },
        horizontalAlign: {
            source: 'static',
            value: 'flex-start',
        },
        isDecorative: {
            source: 'static',
            value: false,
        },
    }
});